import Link from 'next/link'
import SocialProof from '../ckan/SocialProof';
import Grid from './Grid';
import Features from './Features';
import { Testimonials } from './Testimonials';
import Hero from './Hero';
import Highlight from './Highlight.jsx'
import Head from 'next/head';
import Script from 'next/script';


export default function Solutions() {
  return (
    <section className="bg-homeExpert bg-no-repeat bypass-filter bg-solutionPosition !overflow-x-hidden"
    >
      <section>
        <Hero  topTitle="Our Solutions" title="Embrace evolving needs, build nimble solutions, deliver value." subtitle="Experts since 2004. Let us transform your data landscape with customized, innovative, and agile solutions." />
      </section>
      <section className='pt-8'>
        <SocialProof />
      </section>
      <section className=' relative w-screen max-w-screen overflow-hidden lg:flex-row bg-gradient-to-b from-transparent to-[#F7F8F9]'>
          <Highlight subtitle="EXPERTS SINCE 2004" topTitle="Two Decades of Data Excellence"
            text="For nearly two decades, Datopian has been building data management platforms. We combine a mature open-source framework built on best-of-breed tooling with an extensive set of associated services including hosting, integration and customization."
           />
           <Highlight subtitle="YOUR RELIABLE DATA PARTNER" topTitle="Discover the diverse range of data-related services we offer"
            text=" At the heart of our approach is a commitment to 
            providing tailored, innovative, and comprehensive 
            solutions that address your unique data 
            challenges. From open data portals and data 
            catalogs to internal data management and 
            bespoke data-related solutions, we&apos;re your reliable
            partner in data."
            reverse
           />
      </section>
      <section className='mt-36 relative '>
      <div className="absolute -top-16" id="offerings"></div>
        <Grid  />
      </section>

      <section className=' px-8 sm:px-0 rounded-md flex flex-col'>
        <Features />
      </section>
      <section className='bg-[#F7F8F9] py-20 relative w-screen max-w-screen overflow-hidden px-8' tabIndex={0}>
        <h3 className='text-center mx-auto medium-title font-["Inter"]'>Data Management is complex. We make it easy.</h3>
        <p className='text-center font-["Inter"] text-maingray mt-4 px-8 sm:px-0 mx-auto xl:max-w-4xl lg:max-w-3xl md:max-w-2xl max-w-sm'>Get the answers you need today. Join thousands of happy customers.</p>
        <div className='flex flex-col  sm:flex-row mt-8 gap-y-8 sm:gap-x-8 w-full justify-center px-8 sm:px-0 mx-auto xl:max-w-4xl lg:max-w-3xl md:max-w-2xl max-w-sm'>
         <div className='btn-primary'><Link href="/contact">Email us</Link></div>
        <div className='btn-primary'><Link href="https://calendar.app.google/LT4acVdKn3Cxm2MXA" target="_blank">Schedule a free call</Link></div>
        </div>
      </section>
      <section id="testimonials">
        <Testimonials />
      </section>

    </section>
  );
}
